import React, { useState } from 'react';
import {
    Select,
    Input,
    DateInput,
} from '../../Common';
import {
    Stack,
    Grid,
} from '@mui/material';

const Information = ({
    info, 
    setInfo,
    options
}) => {


    const onChange = (name, value) => {
        const newInfo = {
            ...info,
            [name]: value,
            staffHasError: name === "staff" ? (value ? false : true) : info.staffHasError,
            auditDateHasError: name === "auditDate" ? (value ? false : true) : info.auditDateHasError
        };

        setInfo(newInfo);
    }

    return (
        <Grid container spacing={5} marginTop={"4.5px"}>
            <Grid item xs={6} lg={6}>
                <Stack spacing={"25px"}>
                    <Select
                        required
                        label="Staff"
                        options={options}
                        value={info.staff}
                        error={info.staffHasError}
                        onChange={(e) => onChange("staff", e.target.value)}
                    />
                    <Input
                        fullWidth
                        value={info.infoShared}
                        label="Information Shared"
                        onChange={(e) => onChange("infoShared", e.target.value)}
                    />
                    <Input
                        fullWidth
                        value={info.notes}
                        label="Notes"
                        onChange={(e) => onChange("notes", e.target.value)}
                    />
                </Stack>
            </Grid>
            <Grid item xs={6} lg={6}>
                <Stack spacing={"25px"}>
                    <Input
                        fullWidth
                        value={info.duration}
                        label="Duration (hours)"
                        type="number"
                        onChange={(e) => onChange("duration", e.target.value)}
                    />
                    <DateInput
                        required
                        fullWidth
                        allowFuture
                        allowPast
                        date={info.auditDate}
                        label="Audit Date *"
                        error={info.auditDateHasError}
                        onChange={(date) => onChange("auditDate", date)}
                    />
                </Stack>
            </Grid>
        </Grid>
    );
};

export default Information;
